import { useSyncExternalStore } from "react"

export function rendererIsOnline(): boolean {
    return typeof navigator === "undefined" ? true : navigator.onLine
}

export function subscribeToOnlineStatus(onChange: () => void): () => void {
    if (typeof window === "undefined") return () => undefined
    window.addEventListener("online", onChange)
    window.addEventListener("offline", onChange)
    return () => {
        window.removeEventListener("online", onChange)
        window.removeEventListener("offline", onChange)
    }
}

export function useOnlineStatus(): boolean {
    return useSyncExternalStore(subscribeToOnlineStatus, rendererIsOnline, () => true)
}
